// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HOMEPAGE_BLOG_PHOTOS = "Fotky z p\u0159\u00edsp\u011bvk\u016f";
export const PHOTOS_SHOW_MORE = "V\u00edce p\u0159\u00edsp\u011bvk\u016f...";
